import React from "react";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  card: {
    width: 300,
    height: 300 * 0.63,
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    position: "relative"
  }
});

export const CCBlock = withStyles(styles)(({ classes, children }) => {
  return (
    <Paper elevation={3} className={classes.card}>
      <Box
        display="flex"
        height="100%"
        flexDirection="column"
        justifyContent="space-around"
      >
        {children}
      </Box>
    </Paper>
  );
});
